import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  useFetchBrandsQuery,
  useFetchCategoriesQuery,
  usePostModelMutation,
} from "../../../../store";
import { setModel } from "../../../../store/slices/applicationManagement/managementSlice";
import { closeDialog } from "../../../../store/slices/dialog/dialogSlice";
import { MODEL_DIALOG } from "../../../../store/slices/utils/dialogEnum";
import { useFormik } from "formik";
import modelValidation from "../utils/modelValidation";
import {
  openErrorToast,
  openSuccessToast,
} from "../../../../store/slices/toast/toastSlice";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import CustomSelect from "../../../../components/shared/CustomSelect";
import FormHelperText from "@mui/material/FormHelperText";
import Loading from "../../../../components/shared/Loading";

const ModelForm = () => {
  const dispatch = useDispatch();
  const { modelDialogOpen } = useSelector((state) => state.dialogSlice);
  const { model } = useSelector((state) => state.managementSlice);
  const { data: categories, isLoading: categoriesLoading } =
    useFetchCategoriesQuery();
  const { data: brands, isLoading: brandsLoading } = useFetchBrandsQuery();
  const [postModel, { isLoading }] = usePostModelMutation();
  const handleClose = () => {
    dispatch(setModel(null));
    dispatch(closeDialog(MODEL_DIALOG));
  };
  const formik = useFormik({
    initialValues: {
      id: model?.id ?? 0,
      name: model?.name ?? "",
      brandId: model?.brandId ?? 0,
      categoryId: model?.categoryId ?? 0,
    },
    validationSchema: modelValidation,
    enableReinitialize: true,
    onSubmit: async (values, bag) => {
      try {
        postModel({
          id: formik.values.id,
          brandId: formik.values.brandId,
          categoryId: formik.values.categoryId,
          name: formik.values.name,
        }).then((response) => {
          if (!response.data.isSuccess) {
            dispatch(openErrorToast(response.data.message));
          } else {
            dispatch(openSuccessToast("Model Kaydedildi !"));
            handleClose();
          }
        });
      } catch (error) {
        bag.setErrors({ general: error.response.data.message });
      }
    },
  });
  if (categoriesLoading || brandsLoading)
    return <Loading isLoading={categoriesLoading || brandsLoading} />;

  return (
    <Modal
      open={modelDialogOpen}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "#fff",
          borderRadius: 3,
          boxShadow: 8,
          p: 4,
          minWidth: 320,
          width: 370,
        }}
      >
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{
            mb: 2,
            fontWeight: 700,
            color: "primary.main",
            textAlign: "center",
          }}
        >
          Model Kaydet
        </Typography>
        <FormControl
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          error={formik.touched.categoryId && Boolean(formik.errors.categoryId)}
        >
          <InputLabel id="categoryId-label">Kategori</InputLabel>
          <CustomSelect
            data={categories?.data}
            id="categoryId"
            value={formik.values.categoryId}
            handleChange={formik.handleChange}
          />
          {formik.touched.categoryId && (
            <FormHelperText>{formik.errors.categoryId}</FormHelperText>
          )}
        </FormControl>
        <FormControl
          fullWidth
          sx={{ mt: 1, mb: 1 }}
          error={formik.touched.brandId && Boolean(formik.errors.brandId)}
        >
          <InputLabel id="brandId-label">Marka</InputLabel>
          <CustomSelect
            data={brands?.data}
            id="brandId"
            value={formik.values.brandId}
            handleChange={formik.handleChange}
          />
          {formik.touched.brandId && (
            <FormHelperText>{formik.errors.brandId}</FormHelperText>
          )}
        </FormControl>
        <Stack spacing={2}>
          <TextField
            label="Model Adı"
            name="name"
            value={formik.values.name}
            onChange={formik.handleChange}
            error={formik.touched.name && Boolean(formik.errors.name)}
            helperText={formik.touched.name && formik.errors.name}
            fullWidth
            autoFocus
          />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            fullWidth
            disabled={isLoading}
            sx={{ fontWeight: 700, mt: 2 }}
          >
            Kaydet
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ModelForm;
